import { ModuleFE_Advisor_Expression, ModuleFE_Advisor_Value, ModuleFE_AdvisorSession, ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { valueType_StandardRange } from '@app/hcs-shared';
import { ExpressionType_NormalRange } from '@app/hcs-shared/expression';
import { filterInstances, MUSTNeverHappenException, sortArray, StaticLogger } from '@nu-art/ts-common';
export const variableNormalResolver = (variable, min, max) => {
    const varExpression = ModuleFE_Advisor_Expression.cache.find(exp => exp.associatedVar === variable._id
        && exp.expressionType === ExpressionType_NormalRange.dbKey);
    const expressionFindings = ModuleFE_RuntimeFinding.cache.filter(finding => finding.variableId === varExpression?._id);
    const latestExpressionFinding = sortArray(expressionFindings, finding => finding.__created, true)[0];
    return [
        latestExpressionFinding?.value[0] ?? min,
        latestExpressionFinding?.value[1] ?? max,
    ];
};
export const translateFishboneResults = (results) => {
    const currentEncounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
    return results.reduce((map, result) => {
        const value = ModuleFE_Advisor_Value.cache.unique(result.variable.valueId);
        if (!value)
            throw new MUSTNeverHappenException(`Could not get value for id ${result.variable.valueId}`);
        const fullRange = value.type === valueType_StandardRange ? value.data.fullRange : [0, 0];
        const range = variableNormalResolver(result.variable, fullRange[0], fullRange[1]);
        map[result.variable._id] = filterInstances(result.findings.map(finding => {
            switch (finding.type) {
                case 'numeric': {
                    return {
                        value: finding.value,
                        timestamp: finding.issuedTimestamp ?? finding.__created,
                        currentVisit: finding.encounterId === currentEncounterId,
                        normalMin: range[0],
                        normalMax: range[1],
                        source: finding.source?.type,
                    };
                }
                case 'enumerated': {
                    return {
                        value: finding.valueIds[0],
                        timestamp: finding.issuedTimestamp ?? finding.__created,
                        currentVisit: finding.encounterId === currentEncounterId,
                        source: finding.source?.type,
                    };
                }
                default: {
                    StaticLogger.logWarning('Passed non numeric finding to fishbone translation', finding);
                    return;
                }
            }
        }));
        if (!map[result.variable._id].length)
            delete map[result.variable._id];
        return map;
    }, {});
};
export const translateGraphResults = (results) => {
    const currentEncounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
    return results.reduce((map, result) => {
        map[result.variable._id] = filterInstances(result.findings.map(finding => {
            if (finding.type !== 'numeric') {
                StaticLogger.logWarning('Passed non numeric finding to graph translation', finding);
                return;
            }
            return {
                value: finding.value,
                timestamp: finding.issuedTimestamp ?? finding.__created,
                currentVisit: finding.encounterId === currentEncounterId,
            };
        }));
        return map;
    }, {});
};
//# sourceMappingURL=utils.js.map